import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 101 121"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M63.69 58.855c-1.543-1.81-3.237-3.894-5.03-5.886-10.174-11.3-20.257-22.684-30.61-33.815-4.74-5.094-6.25-10.04-.56-15.069 5.623-4.97 11.148-4.53 16.306 1.188C58.162 21.193 72.51 37.13 87.113 52.83c5.452 5.864 4.182 9.851-1.823 14.196-23.049 16.683-45.968 33.547-68.862 50.443-5.146 3.8-10.052 4.75-14.209-.86-4.586-6.19-.343-9.872 4.414-13.336 17.013-12.392 33.993-24.83 50.9-37.366 2.355-1.746 5.736-2.764 6.157-7.05Zm7.287 59.868c-6.196 0-12.4.213-18.583-.068-4.932-.223-7.9-2.979-7.838-8.174.06-4.912 2.536-8.605 7.463-8.738 13.542-.363 27.104-.285 40.651-.02 4.305.084 7.483 2.89 7.457 7.375-.03 5.146-2.739 9.133-8.25 9.465-6.944.42-13.93.104-20.899.104v.056Z"
    }, null, -1)
  ]));
}
const programmingLanguagePowershell = { render };
export {
  programmingLanguagePowershell as default,
  render
};
//# sourceMappingURL=programming-language-powershell.svg.js.map
